import {
  CLEAR_DOMESTICOS_ACTION,
  FETCH_DOMESTICOS,
} from './actions.type';

import {
  SET_ERROR,
  CLEAR_DOMESTICOS,
  FETCHED_DOMESTICOS,
  FETCHING_DOMESTICOS,
  CLEAR_DOMESTICOS_INFO,
  SET_DOMESTICO,
  FETCHING_DOMESTICO,
  FETCHED_DOMESTICO,
  SUBMITED_DOMESTICOS,
  SUBMIT_DOMESTICOS_ERROR,
  RESET_DOMESTICOS_SUBMIT,
  CLEAR_ALERT_DIALOG,
  RESET_DOMESTICOS_PROCESSING,
  STARTED_DOMESTICOS_PROCESSING,
  GENERATE_CREDENTIAL,
  SHOW_AVISO_PRIVACIDAD,
} from './mutations.type';
// eslint-disable-next-line import/no-cycle
import ApiService from '../common/api.service';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
  alertDialog: false,
  alertDialogMessage: '',
  alertDialogType: 'success',
  loading_domesticos: false,
  processing_domestico: false,
  loading_domestico: false,
};

const getters = {
  is_loading() {
    return state.loading_domesticos;
  },
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
  alertDialog(state) {
    return state.alertDialog;
  },
  alertDialogMessage(state) {
    return state.alertDialogMessage;
  },
  alertDialogType(state) {
    return state.alertDialogType;
  },
  domestico_processing() {
    return state.processing_domestico;
  },
};

const actions = {
  [SHOW_AVISO_PRIVACIDAD](context, domesticoId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_DOMESTICO);
      const url = `domesticos/acuerdo_domestico/${domesticoId}`;
      ApiService.queryBlob(url)
        .then(({ data }) => {
          const buffer = Buffer.from(data, 'base64').toString('base64');
          context.commit(FETCHED_DOMESTICO);
          resolve(buffer);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_DOMESTICO);
        });
    });
  },
  [GENERATE_CREDENTIAL](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_DOMESTICO);
      context.commit(CLEAR_DOMESTICOS_INFO);
      ApiService.post('usuarios/generate_domestic_credential', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [FETCH_DOMESTICOS](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_DOMESTICOS);
      ApiService.post('domesticos/listar_domesticos', data)
        .then(({ data }) => {
          context.commit(FETCHED_DOMESTICOS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_DOMESTICOS);
        });
    });
  },
  [CLEAR_DOMESTICOS_ACTION](context) {
    context.commit(CLEAR_DOMESTICOS);
  },
};

const mutations = {
  [FETCHING_DOMESTICOS](state) {
    state.loading_domesticos = true;
  },
  [FETCHED_DOMESTICOS](state) {
    state.loading_domesticos = false;
  },
  [CLEAR_DOMESTICOS_INFO](state) {
    state.domesticos_info = {};
  },
  [SET_DOMESTICO](state, data) {
    state.domestico_info = data.colaborador;
  },
  [FETCHING_DOMESTICO](state) {
    state.loading_domestico = true;
  },
  [FETCHED_DOMESTICO](state) {
    state.loading_domestico = false;
  },
  [SUBMITED_DOMESTICOS](state, data) {
    state.submited_domestico = true;
    state.alert = true;
    if (data.code !== 0) {
      state.alertType = 'error';
      state.alertMessage = data.message;
    } else {
      state.alertType = 'success';
      state.alertMessage = data.message;
    }
  },
  [SUBMIT_DOMESTICOS_ERROR](state, data) {
    state.processing_domestico = false;
    state.alertDialog = true;
    state.alertDialogType = 'error';
    state.alertDialogMessage = data;
  },
  [RESET_DOMESTICOS_SUBMIT](state) {
    state.submited_domestico = false;
    state.alert = false;
    state.alertMessage = 'default';
    state.alertType = 'warning';
  },
  [CLEAR_ALERT_DIALOG](state) {
    state.alertDialog = false;
    state.alertDialogMessage = '';
    state.alertDialogType = 'success';
  },
  [RESET_DOMESTICOS_PROCESSING](state) {
    state.processing_domestico = false;
  },
  [STARTED_DOMESTICOS_PROCESSING](state) {
    state.processing_domestico = true;
  },
  [SET_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
